export default "__VITE_ASSET__gE9G2R1a__"